"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.function.name");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _configure = require("@/api/configure.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// const caseType = []
var _default = {
  data: function data() {
    return {
      loading: true,
      name: '',
      //仲裁机构名称
      tableData: [],
      tableHeaderColor: this.$tableHeaderColor,
      total: 0,
      currentPage: 1,
      pageLimit: 10,
      //每页请求多少个数据，默认10
      pageSizes: this.$tablePageSizes,
      committeeArr: [],
      //仲裁机构列表
      companyArr: [],
      //企业列表
      caseList: [],
      //案件类型列表
      ruleVisible: false,
      //弹窗显示
      form: {
        companyName: ''
      },
      listTableData: [],
      listTableLoading: false,
      //弹窗表格里面的loading
      title: '',
      //弹窗title
      currentcommId: '',
      currentcommName: ''
    };
  },
  created: function created() {
    var _this = this;
    this.currentPage = 1;
    this.init();
    //仲裁委员会列表
    (0, _configure.getAllCommission)().then(function (res) {
      if (res.code == 1) {
        _this.committeeArr = res.data;
      }
    });
    (0, _configure.getCompayList)().then(function (res) {
      if (res.code == 1) {
        _this.companyArr = res.data;
      }
    });
  },
  methods: {
    // 初始化
    init: function () {
      var _init = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var _yield$getArbitralBod, rows, total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _configure.getArbitralBody)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 2:
              _yield$getArbitralBod = _context.sent;
              rows = _yield$getArbitralBod.rows;
              total = _yield$getArbitralBod.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function init() {
        return _init.apply(this, arguments);
      }
      return init;
    }(),
    //筛选
    screen: function () {
      var _screen = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var _yield$getArbitralBod2, rows, total, _yield$getArbitralBod3, _rows, _total;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.total = 1;
              if (!this.name) {
                _context2.next = 12;
                break;
              }
              _context2.next = 4;
              return (0, _configure.getArbitralBody)({
                name: this.name,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 4:
              _yield$getArbitralBod2 = _context2.sent;
              rows = _yield$getArbitralBod2.rows;
              total = _yield$getArbitralBod2.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context2.next = 20;
              break;
            case 12:
              _context2.next = 14;
              return (0, _configure.getArbitralBody)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 14:
              _yield$getArbitralBod3 = _context2.sent;
              _rows = _yield$getArbitralBod3.rows;
              _total = _yield$getArbitralBod3.total;
              this.tableData = _rows;
              this.total = _total;
              this.loading = false;
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function screen() {
        return _screen.apply(this, arguments);
      }
      return screen;
    }(),
    //点击 清空所有筛选条件
    clearAllConditon: function clearAllConditon() {
      this.name = "";
      this.currentPage = 1;
      this.init();
    },
    // 聚焦表格的事件
    tableInputFocus: function tableInputFocus(val) {
      this.listTableData.forEach(function (item, index) {
        item.showBtn = false;
      });
      this.listTableData[val].showBtn = true;
    },
    // 编辑
    edit: function edit(val) {
      var _this2 = this;
      this.title = '编辑规则';
      this.listTableLoading = true;
      this.ruleVisible = true;
      this.currentcommId = val.id;
      this.currentcommName = val.name;
      if (this.$refs['form']) {
        this.$refs['form'].resetFields();
      }
      this.form.companyName = '';
      (0, _configure.getEvidenceList)({
        commId: val.id
      }).then(function (res) {
        if (res.code == 1) {
          _this2.listTableData = res.data;
          (0, _configure.getallCaseList)(val.id).then(function (res) {
            if (res.code == 1) {
              _this2.listTableLoading = false;
              _this2.caseList = res.data;
              _this2.listTableData.forEach(function (ele) {
                var currentItem = _this2.caseList.find(function (item) {
                  return ele.caseType == item.id;
                });
                if (currentItem) {
                  ele.caseType = currentItem.name;
                } else {
                  ele.caseType = '';
                }
              });
            }
          });
        }
      });
    },
    // 企业数据改变时,规则列表
    checkRuleList: function checkRuleList(val) {
      var _this3 = this;
      var currentId;
      if (this.form.companyName) {
        var currentItem = this.companyArr.find(function (ele) {
          return ele.enterpriseName == val;
        });
        currentId = currentItem.id;
      }
      (0, _configure.getEvidenceList)({
        commId: this.currentcommId,
        enterpriseId: currentId
      }).then(function (res) {
        if (res.code == 1) {
          _this3.listTableData = res.data;
          (0, _configure.getallCaseList)(_this3.currentcommId).then(function (res) {
            if (res.code == 1) {
              _this3.listTableLoading = false;
              _this3.caseList = res.data;
              _this3.listTableData.forEach(function (ele) {
                var currentItem = _this3.caseList.find(function (item) {
                  return ele.caseType == item.id;
                });
                if (currentItem) {
                  ele.caseType = currentItem.name;
                } else {
                  ele.caseType = '';
                }
              });
            }
          });
        }
      });
    },
    //弹窗  确定行
    confirmRow: function confirmRow(index, rows, val) {
      var _this4 = this;
      //判断企业是否有值
      var enterpriseId = null;
      if (this.form.companyName) {
        var currentItem = this.companyArr.find(function (ele) {
          return ele.enterpriseName == _this4.form.companyName;
        });
        enterpriseId = currentItem.id;
      }
      var caseTypeId;
      if (val.caseType) {
        var caseTypeItem = this.caseList.find(function (ele) {
          return ele.name == val.caseType;
        });
        caseTypeId = caseTypeItem.id;
      }
      if (val.id) {
        (0, _configure.editEvidenceList)({
          commName: val.commName,
          commId: val.commId,
          fileName: val.fileName,
          id: val.id,
          enterpriseId: enterpriseId,
          enterpriseName: this.form.companyName,
          caseType: caseTypeId,
          number: val.number
        }).then(function (res) {
          if (res.code == 1) {
            _this4.$message({
              message: '修改成功',
              type: 'success'
            });
          } else {
            _this4.$message.error('该行数据不能为空');
          }
        });
      } else {
        (0, _configure.addEvidenceList)({
          commName: this.currentcommName,
          commId: this.currentcommId,
          fileName: val.fileName,
          enterpriseId: enterpriseId,
          enterpriseName: this.form.companyName,
          caseType: caseTypeId,
          number: val.number
        }).then(function (res) {
          if (res.code == 1) {
            _this4.$message({
              message: '修改成功',
              type: 'success'
            });
          } else {
            _this4.$message.error('该行数据不能为空');
          }
        });
      }
    },
    //弹窗   删除行
    deleteRow: function deleteRow(index, rows, val) {
      var _this5 = this;
      if (val.id) {
        (0, _configure.deleteEvidenceList)(val.id).then(function (res) {
          if (res.code == 1) {
            rows.splice(index, 1);
            _this5.$message({
              message: '移除成功',
              type: 'success'
            });
          }
        });
      } else {
        rows.splice(index, 1);
      }
      if (this.listTableData.length == 0) {
        this.listTableData.push({
          fileName: '',
          number: '',
          caseType: ''
        });
      }
    },
    //弹窗   添加行
    addRows: function addRows() {
      this.listTableData.push({
        fileName: '',
        number: '',
        caseType: ''
      });
    },
    //重置列表
    resetTableList: function () {
      var _resetTableList = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var _yield$getArbitralBod4, rows, total, _yield$getArbitralBod5, _rows2, _total2;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.name) {
                _context3.next = 11;
                break;
              }
              _context3.next = 3;
              return (0, _configure.getArbitralBody)({
                name: this.name,
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 3:
              _yield$getArbitralBod4 = _context3.sent;
              rows = _yield$getArbitralBod4.rows;
              total = _yield$getArbitralBod4.total;
              this.tableData = rows;
              this.total = total;
              this.loading = false;
              _context3.next = 19;
              break;
            case 11:
              _context3.next = 13;
              return (0, _configure.getArbitralBody)({
                limit: this.pageLimit,
                page: this.currentPage
              });
            case 13:
              _yield$getArbitralBod5 = _context3.sent;
              _rows2 = _yield$getArbitralBod5.rows;
              _total2 = _yield$getArbitralBod5.total;
              this.tableData = _rows2;
              this.total = _total2;
              this.loading = false;
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function resetTableList() {
        return _resetTableList.apply(this, arguments);
      }
      return resetTableList;
    }(),
    // 分页事件
    handleSizeChange: function () {
      var _handleSizeChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee4(val) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.pageLimit = val;
              this.resetTableList();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function handleSizeChange(_x) {
        return _handleSizeChange.apply(this, arguments);
      }
      return handleSizeChange;
    }(),
    handleCurrentChange: function () {
      var _handleCurrentChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee5(val) {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              this.currentPage = val;
              this.resetTableList();
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function handleCurrentChange(_x2) {
        return _handleCurrentChange.apply(this, arguments);
      }
      return handleCurrentChange;
    }()
  }
};
exports.default = _default;